import { useEffect, useState } from "react";
import Lenis from "lenis";
import "@/App.css";
import { Toaster } from "./components/ui/sonner";
import { Nav } from "./components/site/Nav";
import { Hero } from "./components/site/Hero";
import { Marquee } from "./components/site/Marquee";
import { Benefits } from "./components/site/Benefits";
import { Security } from "./components/site/Security";
import { Pricing } from "./components/site/Pricing";
import { Steps } from "./components/site/Steps";
import { LeadForm } from "./components/site/LeadForm";
import { Footer, LegalDialog } from "./components/site/Footer";
import { MobileCTA } from "./components/site/MobileCTA";
import { LangProvider } from "./i18n";

function App() {
  const [size, setSize] = useState("");
  const [legal, setLegal] = useState(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let id;
    const raf = (t) => { lenis.raf(t); id = requestAnimationFrame(raf); };
    id = requestAnimationFrame(raf);
    return () => { cancelAnimationFrame(id); lenis.destroy(); window.__lenis = null; };
  }, []);

  return (
    <LangProvider>
    <div className="App bg-[#FDFBF7]">
      <Nav />
      <main>
        <Hero />
        <Marquee />
        <Benefits />
        <Security />
        <Pricing onSelect={setSize} />
        <Steps />
        <LeadForm size={size} setSize={setSize} onLegal={setLegal} />
      </main>
      <Footer onLegal={setLegal} />
      <MobileCTA />
      <LegalDialog open={legal} onClose={() => setLegal(null)} />
      <Toaster position="top-center" richColors />
    </div>
    </LangProvider>
  );
}

export default App;
